<template>
    <!-- currency: lets next-admin scope the brand filter to the selected
         economic zone (EUR/GBP). clientId: first brand of the user, if any. -->
    <AdminNextIframe
        path="/dashboard-stock/"
        with-currency
        :query="{ clientId: firstClientId }" />
</template>

<script>
import { mapGetters } from 'vuex';
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'DashboardStockNext',
    components: { AdminNextIframe },
    computed: {
        ...mapGetters(['activeUser']),
        firstClientId() {
            return this.activeUser?.clients?.[0]?.id;
        }
    }
}
</script>
